$(document).ready(function () {
    let mouseOutTimer;
    let mouseOutHideDelay = 50;
    let menuVisible = false;

    function setMegaMenuHeight() {
        $('.mega-menu.clone').css('min-height', 0);
        $('.mega-menu.clone').css('min-height', $('.mega-menu__grid--abs.is-active>.column:not(.mega-menu__block--visible-mob)').height() + 'px')
    }

    function updateReviews() {
        if ($('.mega-menu .is-okeReviews-clickable').length > 0) {
            $('.mega-menu .is-okeReviews-clickable').removeAttr('role').removeAttr('tabindex');
        }
    }

    function showMegaMenu() {
        $('body').addClass('is-show-mega-menu');
        menuVisible = true;
        setMegaMenuHeight();
        updateReviews();
    }

    function hideMegaMenu() {
        $('body').removeClass('is-show-mega-menu');
        $('.js-mega-menu-navbar-item').removeClass('is-mega-menu-open');
        $('.js-mega-menu-mobile-desktop').removeClass('is-active');
        menuVisible = false;
    }

    function getHeaderHeight() {
        var height = $("#shopify-section-header").height();
        if ($('#shopify-section-store-locator-form'.length > 0)) {
            height += $('#shopify-section-store-locator-form').height();
        }
        return height;
    }

    setMegaMenuHeight();
    $(window).on('resize', () => {
        setMegaMenuHeight();
    })

    function showMegaNavBlock(menuLink, navItem) {
        $('.js-mega-menu-navbar-item').removeClass('is-mega-menu-open');
        navItem.addClass('is-mega-menu-open');
        $('.mega-menu.clone').removeClass('is-active');
        $('.mega-menu[data-parent-link=' + menuLink + ']').css("top", getHeaderHeight());
        $('.mega-menu[data-parent-link=' + menuLink + ']').addClass('is-active');
        showMegaMenu();
    }


    $('.js-mega-menu-navbar-item').each(function () {
        var navItem = $(this);
        var linkAttr = $(this).attr('data-navlink-handle');
        var menu = $('div[data-parent-link=' + linkAttr + ']');
        let navToggleButton = navItem.find('.js-mega-menu-navbar-toggle');
        if (menu.length > 0) {
            navItem.on('mouseout', () => {
                mouseOutTimer = setTimeout(() => {
                    hideMegaMenu();
                    navToggleButton.attr('aria-expanded', 'false');
                }, mouseOutHideDelay);
            });
            navItem.on('mouseover', () => {
                showMegaNavBlock(linkAttr, navItem);
                navToggleButton.attr('aria-expanded', 'true');
                clearTimeout(mouseOutTimer);
            });
            navItem.find(`#${navToggleButton.attr('aria-controls')}`).remove();
            menu.attr('id', navToggleButton.attr('aria-controls'));
            navToggleButton.attr('href', '#').on('click', (e) => {
                e.preventDefault();
                if (menuVisible) {
                    hideMegaMenu();
                    navToggleButton.attr('aria-expanded', 'false');
                } else {
                    showMegaNavBlock(linkAttr, navItem);
                    navToggleButton.attr('aria-expanded', 'true');
                }
            });

        }
        navItem.on('keydown', (e) => {
            let lastItem = navItem.find('.mega-menu__block--menu .mega-menu__linklist-item:last-child').find('.is-active').find('button, [href]').last()[0];
            if (lastItem == undefined) {
                lastItem = navItem.find('.mega-menu__linklist-item:last-child>button,.mega-menu__linklist-item:last-child>button>[href]').last()[0];
            }
            if ((e.key == 'Tab' && !e.shiftKey && e.target == lastItem) || e.key == 'Escape') {
                hideMegaMenu();
                if (menu.length > 0) {
                    navToggleButton.attr('aria-expanded', 'false');
                }
            }
            if (e.key == 'Escape') {
                if (menu.length > 0) {
                    navToggleButton.focus();
                }
            }
        });

    });

    $('button.js-mega-menu-sub-toggle').each(function () {
        var element = $('.js-mega-menu-column[data-value="' + $(this).attr('data-value') + '"]');
        if (element.length > 0) {
            $(this).on('click mouseover', function (e) {
                e.preventDefault();
                $('.js-mega-menu-column').removeClass('is-active');
                $('.js-mega-menu-sub-toggle').removeClass('is-active');
                $('button.js-mega-menu-sub-toggle').attr('aria-expanded', false);
                element.addClass('is-active');
                $(this).addClass('is-active');
                $(this).attr('aria-expanded', true);
            });

        }
    })

    $('a.js-mega-menu-sub-toggle').each(function () {
        var element = $('.js-mega-menu-column[data-value="' + $(this).attr('data-value') + '"]');
        if (element.length > 0) {
            $(this).on('mouseover', function (e) {
                $('.js-mega-menu-column').removeClass('is-active');
                $('.js-mega-menu-sub-toggle').removeClass('is-active');
                $('button.js-mega-menu-sub-toggle').attr('aria-expanded', false);
                element.addClass('is-active');
                $(this).addClass('is-active');
                $(this)?.next().attr('aria-expanded', true);
            });
        }
    });


    $('.js-mega-menu-mobile').each(function () {
        var element = $('.js-mega-menu-parent-mobile[data-value="' + $(this).attr('data-value') + '"]');
        if (element.length > 0) {
            const consolidatedMenu = $('.js-mega-menu-mobile-consolidated[data-parent-link="' + $(this).attr('data-value') + '"]');
            if (consolidatedMenu) {
                element.after(consolidatedMenu.find('.mobile-nav__item'));
            }
            element.after($(this).find('.mobile-nav__item'));
            element.remove();
        }

    });

    $('.js-mega-menu-toggle-mobile').on('click', function (e) {
        e.preventDefault();
        $(this).toggleClass('is-open');
        $(this).next().slideToggle(300);
        $(this).next().find('.slick-slider').slick('refresh');
    });

    document.querySelectorAll('.js-mega-menu-mobile-desktop').forEach((megaMenu) => {
        const target = document.querySelector(`[data-navlink-handle="${megaMenu.getAttribute('data-parent-link')}"]`);
        target.appendChild(megaMenu);
        target.classList.add('has-component-mega-menu');
    });

});